import React from 'react'
import {BottomMenu} from '@therms/atalaya'
import {EventsMobileMenuLink} from '@src/modules/Events/shared/Layout/MobileMenuLink'
import {LocationsMobileMenuLink} from '@src/modules/Locations/shared/Layout/MobileMenuLink'
import {RecordsMobileMenuLink} from '@src/modules/Records/shared/Layout/MobileMenuLink'
import {ReportsMobileMenuLink} from '@src/modules/Reports/shared/Layout/MobileMenuLink'
import {UsersMobileMenuLink} from '@src/modules/Users/shared/Layout/MobileMenuLink'
import {DashboardMobileMenuLink} from '@src/modules/Dashboard/shared/Layout/MobileMenuLink'
import {SchedulingMobileMenuLink} from '@src/modules/Scheduling/shared/Layout/MobileMenuLink'
import {useCurrentOrganization} from '@therms/react-modules'
import {MailMobileMenuLink} from '@src/modules/Mail/shared/Layout/MobileMenuLink'
import {PatrolMobileMenuLink} from '@src/modules/Patrol/shared/Layout/MobileMenuLink'
import {BulletinsMobileMenuLink} from '@src/modules/Bulletins/shared/Layout/MobileMenuLink'
import {ReviewMobileMenuLink} from '@src/modules/Review/shared/Layout/MobileMenuLink'

function MobileNav() {
  const {
    modules: {patrol, scheduling},
  } = useCurrentOrganization()

  return (
    <BottomMenu background="surface">
      <nav className="flex">
        <ReviewMobileMenuLink />
        <DashboardMobileMenuLink />
        <EventsMobileMenuLink />
        <LocationsMobileMenuLink />
        {patrol && <PatrolMobileMenuLink />}
        <RecordsMobileMenuLink />
        <ReportsMobileMenuLink />
        <UsersMobileMenuLink />
        {scheduling && <SchedulingMobileMenuLink />}
        <BulletinsMobileMenuLink />
        <MailMobileMenuLink />
      </nav>
    </BottomMenu>
  )
}

export {MobileNav}
